import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'

export const StratificationQUsSkeleton: FC = () => {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Skeleton height={28} variant="text" width={140} />
      <Skeleton height={64} variant="rectangular" width="100%" />
      <Skeleton height={64} variant="rectangular" width="100%" />
      <Skeleton height={28} variant="text" width={140} />
      <Skeleton height={64} variant="rectangular" width="100%" />
    </Stack>
  )
}
